import React, { Fragment, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Hero3 from "../../components/hero3/hero3";
import Scrollbar from "../../components/scrollbar/scrollbar";
import ServiceSectionS2 from "../../components/ServiceSectionS2/ServiceSectionS2";
import WorkSection from "../../components/WorkSection/WorkSection";
import Appointment from "../../components/Appointment/Appointment";
import ProjectSection from "../../components/ProjectSection/ProjectSection";
import TeamSection from "../../components/TeamSection/TeamSection";
import Testimonial from "../../components/Testimonial/Testimonial";
import BlogSection from "../../components/BlogSection/BlogSection.js";
import PartnerSection from "../../components/PartnerSection/PartnerSection";
import Footer from "../../components/footer/Footer.js";
import { useLocation } from "react-router-dom";

const Homepage3 = () => {
  const location = useLocation();
  console.log(location);
  useEffect(() => {
    setTimeout(() => {
      if (location.hash === "#quotation") {
        const quotationSection = document.getElementById("quotation");
        if (quotationSection) {
          quotationSection.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, 300);
  }, [location]);
  return (
    <Fragment>
      <Navbar topbarNone={"topbar-none"} />
      <Hero3 />
      <ServiceSectionS2 />
      <WorkSection />
      <div id="quotation">
        <Appointment />
      </div>
      {/* <ProjectSection /> */}
      <TeamSection />
      <Testimonial />
      {/* <BlogSection /> */}
      <PartnerSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default Homepage3;
